import { Raffle } from '@/app/entities/Raffle'
import { withCdn } from '@/app/utils/withCdn'
import { format, isValid } from 'date-fns'
import { Award } from 'lucide-react'
import { raffleHasEnded } from '../utils'

interface RaffleInfoProps {
  raffle: Raffle
}

const RaffleInfo = ({ raffle }: RaffleInfoProps) => {
  const hasGallery = raffle?.gallery?.length > 0
  const hasEnded = raffleHasEnded(raffle)

  const formattedDate = isValid(new Date(raffle?.resultDate))
    ? format(new Date(raffle?.resultDate), 'dd/MM/yyyy')
    : 'Indefinido'

  return (
    <div className="flex w-full gap-5">
      <div
        className="flex h-[451px] items-end justify-center rounded-3xl bg-cover bg-center p-5"
        style={{
          backgroundImage: `url(${withCdn(raffle?.banner)})`,
          aspectRatio: '1179 / 1600',
        }}
      >
        {hasEnded && (
          <div className="relative flex w-full items-center justify-center rounded-xl p-5">
            <div className="absolute inset-0 rounded-xl bg-white bg-opacity-45 backdrop-blur-sm"></div>
            <h1 className="relative z-10 flex items-center font-semibold text-black">
              <Award className="mr-2 inline-block" /> Sorteio finalizado
            </h1>
          </div>
        )}
      </div>
      <div className="w-full rounded-3xl border p-5">
        <h1 className="mb-[10px] text-2xl font-semibold">{raffle?.name}</h1>
        <p className="whitespace-pre-line">{raffle?.description}</p>
        <div className="mt-[10px] flex items-center justify-center gap-2 rounded-2xl bg-gray-100 px-3 py-4">
          Sorteio:
          <span className="font-semibold">{formattedDate}</span>
        </div>
        {hasGallery && (
          <div className="mt-[10px] flex gap-2">
            {raffle?.gallery?.map((image, index) => (
              <img
                key={index}
                src={`${import.meta.env.VITE_CDN_URL}/${image}`}
                alt={raffle?.name}
                className="h-[112px] w-[112px] rounded-lg object-contain object-center"
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default RaffleInfo
